import type * as d3 from 'd3';

export enum EVENT_TYPES {
  TEXTCLICK = 'TextClick'
}

export interface Callback {
  (...args: any[]): any;
}

export type SVGSelection = d3.Selection<SVGSVGElement, unknown, null, undefined>;

export type D3Selection = d3.Selection<d3.BaseType, unknown, null, undefined>;

export type HotSpotSelection = d3.Selection<
  SVGTextElement | SVGRectElement | SVGGElement,
  unknown,
  null,
  undefined
>;

export type LineSelection = d3.Selection<
  SVGLineElement | SVGPolylineElement,
  unknown,
  null,
  undefined
>;

export interface InitialOpt {
  svgElement: SVGSVGElement;
  defaultPCode: string;
  paramMaps: Record<string, string>;
  validPCodeList: string[];
}
